/* ============
 * Add Batch Log Component
 * ============
 *
 * This is the component for creating batch log
 */
import { mapMutations } from 'vuex';
import helpers from '../../utils/helpers';
import clientService from '../../services/client';
import store from '../../store';
import ClientImportExportErrorReport from './../../components/clientImportExportErrorReportPopup/clientImportExportErrorReportPopup.vue';

export default {

  data() {
    return {
      server: {
        url: helpers.buildUrl(`${process.env.API_LOCATION}/clients/import`, {
          token: localStorage.getItem('id_token'),
        }),
        process: {
          onload: this.import,
          onerror: this.error,
        },
      },
    };
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      setModalContent: 'SET_MODAL_CONTENT',
    }),

    downloadAllClients() {
      window.open(helpers.buildUrl(`${process.env.API_LOCATION}/clients/download`, {
        token: localStorage.getItem('id_token'),
      }));
    },

    import(response) {
      const result = JSON.parse(response);
      if (!result.errors.length && result.data.length) {
        const params = {
          page: 1,
          limit: 50,
        };
        store.dispatch('setClientQuery', params);
        clientService.items(params)
        .then(() => {
          this.$message({
            showClose: true,
            message: 'Successfully imported products.',
            type: 'success',
          });
          this.closeModal();
        });
      } else if (result.errors.length) {
        this.setModalProps({
          errors: result.errors,
        });
        this.toggle(true);
        this.setModalContent(() => ClientImportExportErrorReport);
      } else {
        const message = result.error || this.$t('static.products.index.importProductsErrorMessage');
        this.$message({
          showClose: true,
          message,
          type: 'error',
        });
      }
    },
    error(response) {
      const result = JSON.parse(response);
      const message = result.message || this.$t('static.products.index.importProductsErrorMessage');
      this.$message({
        showClose: true,
        message,
        type: 'error',
      });
    },
    /*
    * Closes the modal
    */
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/clientImportExportPopup/clientImportExportPopup.js